import { render, staticRenderFns } from "./PeopleField.vue?vue&type=template&id=7ffdba0e&"
import script from "./PeopleField.vue?vue&type=script&lang=js&"
export * from "./PeopleField.vue?vue&type=script&lang=js&"
import style0 from "./PeopleField.vue?vue&type=style&index=0&id=7ffdba0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports